/**
 * Custom footing (zapata) icon — replaces the comical `Footprints` icon from
 * lucide which literally shows two shoes ("zapatos"). This silhouette matches
 * the classic structural-engineering symbol for an isolated footing: a column
 * stub rising from the wider footing slab (inverted-T shape).
 *
 * Follows the lucide-react icon API (size, strokeWidth, color via currentColor).
 */

interface Props {
  size?: number;
  strokeWidth?: number;
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
}

export function FootingIcon({
  size = 16,
  strokeWidth = 1.6,
  className,
  ...rest
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      {/* Column stub (centered, top) */}
      <rect x="9" y="4" width="6" height="9" />
      {/* Footing slab (wider, bottom) */}
      <rect x="3" y="13" width="18" height="6" />
      {/* Ground line under the footing */}
      <line x1="2" y1="20.5" x2="22" y2="20.5" />
    </svg>
  );
}
